import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useErrorHandler from "../../hooks/useErrorHandler";
import { getCategory } from "../../apis/categoryApis";
import { isNumber } from "../../common/CommonUtils";
import { useToast } from "../../components/common/ToastProvider";
import CategoryForm from "../../components/forms/CategoryForm";
import { Button } from "primereact/button";
import { t } from "i18next";

const CategoryUpdatePage = () => {
  const { categoryId } = useParams();

  const [category, setCategory] = useState({});

  const [loadingGetCategory, setLoadingGetCategory] = useState(true);

  const handleError = useErrorHandler();

  const navigate = useNavigate();

  const { showError } = useToast();

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await getCategory(categoryId);
        setCategory(response.data);
        setLoadingGetCategory(false);
      } catch (error) {
        handleError(error);
        navigate("/categories/list");
      }
    };

    if (isNumber(categoryId)) {
      fetchCategory();
    } else {
      showError("Not valid id");
      navigate("/categories/list");
    }
  }, []);

  return (
    !loadingGetCategory && (
      <>
        <Button
          className="p-1"
          label={`< ${t("List Value", { value: t("Category") })}`}
          link
          onClick={() => {
            navigate("/categories/list");
          }}
        />
        <CategoryForm
          action="UPDATE"
          category={category}
          setCategory={setCategory}
        />
      </>
    )
  );
};

export default CategoryUpdatePage;
